module.exports = "/assets/delice.png?SLNYM3d";